import { render, staticRenderFns } from "./InputRange.vue?vue&type=template&id=8515cf56&"
import script from "./InputRange.vue?vue&type=script&lang=js&"
export * from "./InputRange.vue?vue&type=script&lang=js&"
import style0 from "./InputRange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports